export const LOCALSTORAGE_EXPIRY_MINUTES = 120;
export const LOCALSTORAGE_METADATA = 'payments-on-hold-metadata';
